<template>
   <div class="error_wrap">
    <div class="container-fluid-xl">
    <div class="error_vipps text-center">
       <img src="~@/assets/vipp3.gif" alt="success_order">
       <div class="div2s">
           <p>  Please wait for confirmation of everything just moments  <svg id="rotateload" aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"/></svg></p>
         <!-- <b-button tag="router-link" to="/meny" type="is-success">{{get_local_string.string_106}}</b-button> -->
       </div>
    </div>
   </div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name:'error_vipps_order',
     computed:{
        ...mapGetters({
        get_local_string:'get_local_string'
        })
    },
    methods:{
        time_process(){
            setTimeout(()=>{
                window.location.href = 'https://smile3.no/admin/payment-vipps-vue/'+this.$route.params.ordercode;
            },4000)
        }
    },
    mounted(){
        console.log('mount page');
        this.time_process();
    },
    
}
</script>
<style lang="scss" scoped>
.error_vipps{
    padding-top:45px;
    padding-bottom:30px;
    position:relative;
    z-index:2;
    min-height:calc(100vh - 300px);
    img{
      width: 550px;
    margin-bottom: 0px;
    }
    p{
        font-size:14px;
        font-weight:600;
        color:#000;
        margin-bottom:15px;
    }
    .div2s{
           margin-top: -60px;
    margin-bottom: 30px;
    #rotateload{
      width: 50px;
    height: 25px;
    margin-top: -5px;
        animation: loading 2s linear infinite;
       -webkit-animation: loading 2s linear infinite;
    -moz-animation: loading 2s linear infinite;
    path{
        fill:#ff5d27;
    }
    }
    }
}
@keyframes loading {
    from {
        -webkit-transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
    }
}
@-webkit-keyframes loading {
    from {
        -webkit-transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
    }
}
@-moz-keyframes loading {
    from {
        -moz-transform: rotate(0deg);
    }
    to {
        -moz-transform: rotate(360deg);
    }
}


</style>